import { TicketingClosed } from './TicketingClosed';
import { TicketsPage } from './Tickets';

export const Ticketing = () => {
  if (new Date().getTime() > new Date('2025-11-08T21:00:00.000Z').getTime()) {
    return <TicketingClosed />;
  }

  return <TicketsPage />;
};
